import type { ITableCell } from './table-cell/table-cell.interface';
import { DataTableColumnTypeEnum } from '@seb/web-design-system/core';

export interface IDataTableColumn {
  readonly id: string;
  readonly label: ITableCell;
  readonly width: number;
  readonly doubleEntry?: boolean;
  readonly type?: DataTableColumnTypeEnum;
  readonly hidden?: boolean;
}

export class DataTableColumn implements IDataTableColumn {
  readonly id: string;
  readonly label: ITableCell;
  readonly width: number;
  readonly doubleEntry?: boolean;
  readonly type?: DataTableColumnTypeEnum;
  readonly hidden?: boolean;

  constructor(
    id: string,
    label: ITableCell,
    width: number,
    doubleEntry?: boolean,
    type?: DataTableColumnTypeEnum,
    hidden?: boolean,
  ) {
    this.id = id;
    this.label = label;
    this.width = width;
    this.doubleEntry = doubleEntry;
    this.type = type;
    this.hidden = hidden;
  }
}
